import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const SignupPage = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState('user');
  const [licenseText, setLicenseText] = useState('');
  const [carPlate, setCarPlate] = useState('');
  const [carType, setCarType] = useState('');
  const navigate = useNavigate();

  const handleSignup = (e) => {
    e.preventDefault();
    setErrorMsg('');
    const u = username.trim();
    const em = email.trim();
    const pw = password;
    // Basic client-side checks mirroring backend
    if (!u || !em || !pw) {
      setErrorMsg('All fields are required.');
      return;
    }
    if (u.length < 3) {
      setErrorMsg('Username must be at least 3 characters.');
      return;
    }
    if (pw.length < 8) {
      setErrorMsg('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    authService.signup(u, em, pw, role, licenseText.trim(), carPlate.trim(), carType.trim())
      .then((res) => {
        const token = res.data?.verifyToken;
        const qp = new URLSearchParams();
        if (token) qp.set('token', token);
        qp.set('email', em);
        qp.set('username', u);
        navigate(`/verify-email?${qp.toString()}`);
      })
      .catch((error) => {
        const serverMsg = error?.response?.data?.message || error?.data?.message || error?.message;
        setErrorMsg(serverMsg || 'Signup failed. Please check your connection and try again.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex justify-center items-center min-h-screen" style={{ backgroundColor: 'rgb(var(--bg))' }}>
      <div className="w-full max-w-md p-8 space-y-8 rounded-2xl shadow-lg" style={{ backgroundColor: 'rgb(var(--surface))', border: '1px solid rgb(var(--border))' }}>
        <div className="text-center">
          <h1 className="text-2xl font-bold">Create an account</h1>
        </div>
        <form className="space-y-6" onSubmit={handleSignup}>
          <input
            type="text"
            placeholder="Username"
            className="w-full p-4 rounded-2xl focus:outline-none focus:ring-2 bg-white dark:bg-white/10 text-black dark:text-white"
            style={{ border: '1px solid rgb(var(--border))' }}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="email"
            placeholder="Your email address"
            className="w-full p-4 rounded-2xl focus:outline-none focus:ring-2 bg-white dark:bg-white/10 text-black dark:text-white"
            style={{ border: '1px solid rgb(var(--border))' }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              className="w-full p-4 rounded-2xl focus:outline-none focus:ring-2 bg-white dark:bg-white/10 text-black dark:text-white"
              style={{ border: '1px solid rgb(var(--border))' }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 px-4"
              style={{ color: 'rgb(var(--muted))' }}
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="isDriver"
              checked={role === 'taxiDriver'}
              onChange={(e) => setRole(e.target.checked ? 'taxiDriver' : 'user')}
              className="w-4 h-4"
            />
            <label htmlFor="isDriver" className="text-sm" style={{ color: 'rgb(var(--text))' }}>
              Register as Driver
            </label>
          </div>
          {role === 'taxiDriver' && (
            <div className="space-y-4 p-4 rounded-2xl" style={{ backgroundColor: 'rgb(var(--bg))', border: '1px solid rgb(var(--border))' }}>
              <input
                type="text"
                placeholder="License Number"
                className="w-full p-4 rounded-2xl focus:outline-none focus:ring-2 bg-white dark:bg-white/10 text-black dark:text-white"
                style={{ border: '1px solid rgb(var(--border))' }}
                value={licenseText}
                onChange={(e) => setLicenseText(e.target.value)}
              />
              <input
                type="text"
                placeholder="Car Plate Number"
                className="w-full p-4 rounded-2xl focus:outline-none focus:ring-2 bg-white dark:bg-white/10 text-black dark:text-white"
                style={{ border: '1px solid rgb(var(--border))' }}
                value={carPlate}
                onChange={(e) => setCarPlate(e.target.value)}
              />
              <input
                type="text"
                placeholder="Car Type (e.g., Sedan, SUV)"
                className="w-full p-4 rounded-2xl focus:outline-none focus:ring-2 bg-white dark:bg-white/10 text-black dark:text-white"
                style={{ border: '1px solid rgb(var(--border))' }}
                value={carType}
                onChange={(e) => setCarType(e.target.value)}
              />
            </div>
          )}
          <button disabled={loading} className="w-full p-4 rounded-2xl font-bold text-lg shadow-lg disabled:opacity-50 disabled:cursor-not-allowed" style={{ backgroundColor: 'rgb(var(--brand))', color: '#fff' }}>
            {loading ? 'Creating account...' : 'Sign up'}
          </button>
          {errorMsg && <p className="text-sm text-center" style={{ color: '#dc2626' }}>{errorMsg}</p>}
        </form>
        <div className="text-center" style={{ color: 'rgb(var(--muted))' }}>
          Already have an account?{' '}
          <Link to="/login" className="text-blue-500 hover:underline">
            Log in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;
